import { useEffect, useState } from "react";

export default function ProcessSection() {
	const [isVisible, setIsVisible] = useState(false);

	useEffect(() => {
		const observer = new IntersectionObserver(
			([entry]) => {
				if (entry.isIntersecting) {
					setIsVisible(true);
				}
			},
			{ threshold: 0.1 }
		);

		const element = document.getElementById("processo");
		if (element) {
			observer.observe(element);
		}

		return () => observer.disconnect();
	}, []);

	const steps = [
		{
			number: "01",
			title: "Diagnóstico",
			description:
				"Análise completa da situação atual da sua empresa, identificando oportunidades e necessidades específicas.",
			icon: "ri-search-line",
			color: "bg-blue-500",
		},
		{
			number: "02",
			title: "Plano de Ação",
			description:
				"Elaboração de estratégia personalizada com cronograma detalhado e objetivos claros para seu negócio.",
			icon: "ri-file-list-line",
			color: "bg-green-500",
		},
		{
			number: "03",
			title: "Execução",
			description:
				"Implementação das soluções com acompanhamento constante e comunicação transparente sobre o progresso.",
			icon: "ri-settings-line",
			color: "bg-purple-500",
		},
		{
			number: "04",
			title: "Acompanhamento",
			description:
				"Monitoramento contínuo dos resultados com relatórios regulares e ajustes quando necessário.",
			icon: "ri-line-chart-line",
			color: "bg-orange-500",
		},
	];

	return (
		<section id="processo" className="py-10 bg-white">
			<div className="container mx-auto px-4">
				<div className="text-center mb-16">
					<h2
						className="text-4xl font-bold text-gray-800 mb-4"
						style={{ fontFamily: "DM Sans, sans-serif" }}
					>
						Como Trabalhamos
					</h2>
					<p className="text-xl text-gray-600 max-w-3xl mx-auto">
						Nosso processo estruturado em 4 etapas garante
						resultados eficientes e transparentes
					</p>
				</div>

				<div className="relative">
					{/* Linha conectora */}
					<div className="hidden lg:block absolute top-1/2 left-0 right-0 h-0.5 bg-gray-200 transform -translate-y-1/2"></div>

					<div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
						{steps.map((step, index) => (
							<div
								key={index}
								className={`relative transform transition-all duration-700 md:hover:scale-103 md:hover:-translate-y-6 ${
									isVisible
										? "translate-y-0 opacity-100"
										: "translate-y-10 opacity-0"
								}`}
								style={{ transitionDelay: `${index * 200}ms` }}
							>
								<div className="text-center">
									<div
										className={`w-20 h-20 ${step.color} rounded-full flex items-center justify-center mx-auto relative z-10 shadow-lg`}
									>
										<i
											className={`${step.icon} text-white text-2xl`}
										></i>
									</div>

									<div className="bg-white p-6 rounded-xl shadow-lg md:hover:shadow-2xl transition-all duration-500 h-full">
										<div
											className="text-3xl font-bold text-gray-300 mb-2"
											style={{
												fontFamily:
													"DM Sans, sans-serif",
											}}
										>
											{step.number}
										</div>
										<h3
											className="text-2xl font-semibold text-gray-800 mb-4 "
											style={{
												fontFamily:
													"DM Sans, sans-serif",
											}}
										>
											{step.title}
										</h3>
										<p className="text-gray-600 leading-relaxed text-base sm:text-xl">
											{step.description}
										</p>
									</div>
								</div>
							</div>
						))}
					</div>
				</div>
			</div>
		</section>
	);
}
